export default __webpack_public_path__ + "static/media/bateriafront.2ee596aa.png";